/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { useContext, useEffect, useState } from 'react'
import { KTIcon } from '../../../helpers'
import { Dropdown1 } from '../../content/dropdown/Dropdown1'
import { BLACKBOXES_GET_5_ERROR_URL } from '../../../../urls'
import { blackboxIdContext } from '../../../../app/modules/profile/components/contexts/BlackboxIdContext'
import { useAuth } from '../../../../app/modules/auth'

type Props = {
  className: string
}

const Blackbox5Error: React.FC<Props> = ({ className }) => {
  const currentBlackBoxId = useContext(blackboxIdContext);
  const [errorList, setErrorList] = useState<any[]>([])
  /**
   * Yükleniyor / liste / hata.
   *
   * `loading` boolean'ı yerine üç durum, çünkü **boş liste iyi haber**: bir vinçte son 5
   * hatanın olmaması "arıza yok" demek. Önceden hem "arıza yok" hem "veriyi alamadım"
   * aynı şeyi gösteriyordu -- bomboş bir kart. İzleme ürününde bu ikisinin karışması
   * tehlikeli.
   */
  const [state, setState] = useState<'loading' | 'ready' | 'error'>('loading')

  const { currentUser, logout } = useAuth()
  const token = currentUser?.token


  const createHeader = () => {
    const headers = new Headers();
    headers.append('Content-Type', 'application/json');
    headers.append('Authorization', "" + token?.toString());
    return headers
  }


  useEffect(() => {
    const blackboxId = currentBlackBoxId[0]
    if (!blackboxId) {
      return
    }
    let cancelled = false
    // `setTimeout(() => setLoading(true), 3000)` KALDIRILDI: hiç temizlenmeyen, "veri bu
    // arada gelmiştir" varsayımına dayanan bir zamanlayıcıydı. Hata durumunda listeyi
    // açan tek şey o üç saniyeydi.
    void loadLast5Errors(blackboxId, cancelled)
    return () => {
      cancelled = true
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [currentBlackBoxId[0]])

  /**
   * Son 5 hatayı çeker.
   *
   * Önceden hiçbir denetim yoktu: ne `response.ok`, ne 401, ne `catch`. Hata gövdesi
   * `res.json()` ile ayrıştırılıp `setErrorList(<hata nesnesi>)` yapılıyordu; bir nesnenin
   * `.length`'i `undefined` olduğu için render koşulu (`errorList.length > 0`) sessizce
   * false kalıyor ve kart boş görünüyordu.
   */
  async function loadLast5Errors(blackboxId: string, cancelled: boolean) {
    try {
      const response = await fetch(BLACKBOXES_GET_5_ERROR_URL + `?blackboxId=${blackboxId}`, {
        method: "GET",
        headers: createHeader(),
      })
      if (response.status === 401) {
        logout()
        return
      }
      if (!response.ok) {
        throw new Error(`HTTP ${response.status}`)
      }
      const data = await response.json()
      if (cancelled) {
        return
      }
      setErrorList(Array.isArray(data) ? data : [])
      setState('ready')
    } catch (error) {
      console.error('Son 5 hata alinamadi:', error)
      if (!cancelled) {
        setErrorList([])
        setState('error')
      }
    }
  }
  return (
    <div className={`card ${className}`}>
      {/* begin::Header */}

      <div className='card-header align-items-center border-0 mt-4'>
        <h3 className='card-title align-items-start flex-column'>
          <span className='fw-bold mb-2 text-dark'>Hatalar</span>
          <span className='text-muted fw-semibold fs-7'>Son 5 hata</span>
        </h3>
        <div className='card-toolbar'>
          {/* begin::Menu */}
          <button
            type='button'
            className='btn btn-sm btn-icon btn-color-primary btn-active-light-primary'
            data-kt-menu-trigger='click'
            data-kt-menu-placement='bottom-end'
            data-kt-menu-flip='top-end'
          >
            <KTIcon iconName='category' className='fs-2' />
          </button>
          <Dropdown1 />
          {/* end::Menu */}
        </div>
      </div>
      {/* end::Header */}
      {/* begin::Body */}

      <div className='card-body pt-5'>
        {/* begin::Timeline */}
        <div className='timeline-label'>
          {/* begin::Item */}
          {state === 'loading' && <div className='text-gray-500'>Yükleniyor…</div>}
          {state === 'error' && <div className='text-danger'>Hata listesi alınamadı.</div>}
          {/* Bos liste ile alinamayan liste AYRI. Ilki iyi haber. */}
          {state === 'ready' && errorList.length === 0 && (
            <div className='text-gray-500'>Son 5 kayıtta hata yok.</div>
          )}
          {
            (state === 'ready' && errorList.length > 0 ) &&
            errorList.map((error: any,index) =>


              <div className='timeline-item' key={index}>
                {/* begin::Label */}
                {/* `error["sendTime"].replace(...)` dogrudan cagriliyordu: alan null
                    gelirse TypeError atip BUTUN SAYFAYI bos birakirdi. */}
                <div className='timeline-label fw-bold text-gray-800 fs-8'>
                  {error["sendTime"] ? String(error["sendTime"]).replace("T", " ") : '-'}
                </div>
                {/* end::Label */}
                {/* begin::Badge */}
                <div className='timeline-badge'>
                  <i className='fa fa-genderless text-danger fs-1'></i>
                </div>
                {/* end::Badge */}
                {/* begin::Text */}
                <div className='fw-mormal timeline-content ps-5'>
                {error["message"]}
                </div>
                {/* end::Text */}
              </div>
            )}  
          
        </div>
        {/* end::Timeline */}
      </div>
      {/* end: Card Body */}
    </div>
  )
}

export { Blackbox5Error }
